import React from 'react';
import Image from '../../elements/Image';


const ProductShortDescription = ({ title, text, imageRoute, width, height, delay }) => {

    return (
        <div className="tiles-item reveal-from-bottom" data-reveal-delay={!delay ? 200 : delay}>
            <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                    <div className="container-xs mb-0">
                        <Image src={imageRoute} width={width} height={height} />
                    </div>
                </div>
                <div className="features-tiles-item-content">
                    <h4 className="mt-10 mb-8">
                        {title}
                    </h4>
                    <p className="m-0 text-xs">
                        {text}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProductShortDescription;
